import { css } from "styled-components";

export const linkStyles = css`
  cursor: pointer;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.textBright};
  text-decoration: none;
  &:hover,
  &:focus {
    text-decoration: underline;
  }
`;
